import { useHistory } from "react-router-dom";
import { PATH_ONBOARDING_TAX_PAYEE } from "..";
import { OnboardingFlow } from "../components/OnboardingFlow";
import { OnboardingModule } from "../types";

const taxPayeeOnboardingModules: OnboardingModule[] = [
  {
    type: "create_account",
    options: {
      accountTypes: ["Business", "Individual"],
      verificationLevel: "Tax",
      show1099Message: true
    }
  },
  {
    type: "certify_tax_payer_info"
  }
];

export const RouteTaxPayeeOnboarding: React.FC = () => {
  const history = useHistory();

  return (
    <OnboardingFlow
      basePath={PATH_ONBOARDING_TAX_PAYEE}
      modules={taxPayeeOnboardingModules}
      onSuccess={() => {
        history.push("/member/dashboard");
      }}
    />
  );
};
